import actions from './actions.js'
import mutations from './mutations'
import getters from './getters.js'

const state = {
  dashboardData: [],
  codingDateRange: [],
  currentlyPending: true,
  reviewDashboardData: [],
  reviewDashboardBaselineSmallStatsIP: [],
  reviewDashboardBaselineSmallStatsOP: [],
  reviewDashboardBaselineSmallStatsAMB: [],
  reviewDashboardBaselineSmallStatsPRO: [],
  dashboardProjects: [],
  codingDashboardProjects: [],
  selectedProjects: [],
  dashboardAccounts: [],
  worksheet: '',
  schedule: '',
  codingLogs: [],
  codingLog: '',
  comparisonAccounts: [],
  comparisonAccountsOP: [],
  comparisonAccountsAMB: [],
  comparisonAccountsPRO: [],
  calendarSchedule: [],
  queryGrouping: 'Category',
  queryDrillDown: 'Physician',
  pendingGrouping: 'Category',
  pendingDrillDown: 'Physician',
  inpatientGrouping: '7',
  inpatientStickyGroupingFilters: [],
  outpatientGrouping: '5',
  outpatientStickyGroupingFilters: [],
  ambulatoryGrouping: '5',
  ambulatoryStickyGroupingFilters: [],
  proGrouping: '4',
  proStickyGroupingFilters: [],
  dxModalData: []
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
